import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { GameResultType, PlayerWinResultType } from './types';

const initialState: {
  gameResult: GameResultType | null;
  megawinValue: [];
  hideWinMessage: boolean;
  result: string | null;
  resultStatus: string | null;
  winingAmount: PlayerWinResultType | null;
} = {
  gameResult: null,
  megawinValue: [],
  hideWinMessage: false,
  result: null,
  resultStatus: null,
  winingAmount: null,
};

export const mwStateSlice = createSlice({
  name: 'mwState',
  initialState,
  reducers: {
    setMegaWinValue: (state, action) => {
      state.megawinValue = action.payload;
    },
    setGameResult: (state, action: PayloadAction<GameResultType | null>) => {
      state.gameResult = action.payload;
    },
    setWinningAmount: (state, action: PayloadAction<PlayerWinResultType | null>) => {
      state.winingAmount = action.payload;
    },
    setHideWinMessage: (state, action) => {
      state.hideWinMessage = action.payload;
    },
    // Reset the game on bets open state
    resetForNewGame: (state) => {
      state.gameResult = null;
      state.resultStatus = null;
      state.megawinValue = [];
      state.hideWinMessage = false;
      state.winingAmount=null;
    },
    resetAfterReconnection: (state) => {
      state.megawinValue = [];
      state.hideWinMessage = false;
      state.resultStatus = null;
      state.winingAmount=null;
    },
  },
});

export const mwStateActions = mwStateSlice.actions;
